import { createDynamicMiddleware } from '@reduxjs/toolkit/react';
import type { RootState, AppDispatch } from '../index';

// pre middleware

export const preMiddleware = createDynamicMiddleware();

interface MiddlewareApiConfig {
  state: RootState;
  dispatch: AppDispatch;
}

export const addPreAppMiddleware = preMiddleware.addMiddleware.withTypes<MiddlewareApiConfig>();

export const withPreAppMiddleware = preMiddleware.withMiddleware.withTypes<MiddlewareApiConfig>();

export const createAppDispatchWithPreMiddlewareHook =
  preMiddleware.createDispatchWithMiddlewareHook.withTypes<MiddlewareApiConfig>();

// post middleware

export const postMiddleware = createDynamicMiddleware();

export const addPostAppMiddleware = postMiddleware.addMiddleware.withTypes<MiddlewareApiConfig>();

export const withPostAppMiddleware = postMiddleware.withMiddleware.withTypes<MiddlewareApiConfig>();

export const createAppDispatchWithPostMiddlewareHook =
  postMiddleware.createDispatchWithMiddlewareHook.withTypes<MiddlewareApiConfig>();
